namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class PaymentsEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "Cash", text: "Cash" });
            this.addItem({ id: "Cheque", text: "Cheque" });
            this.addItem({ id: "Credit Card", text: "Credit Card" });
            this.addItem({ id: "Debit Card", text: "Debit Card" });
            this.addItem({ id: "Transfer", text: "Transfer" });
            //this.addItem({ id: "Scrape", text: "Scrape" });
        }
    }
}